import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar__nav main-nav" }
const _hoisted_3 = { class: "main-nav__icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "main-nav__icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = {
  key: 0,
  class: "sidebar__links"
}
const _hoisted_10 = {
  key: 0,
  class: "sidebar__link"
}
const _hoisted_11 = { class: "sidebar__link-title" }
const _hoisted_12 = { class: "sidebar__link-content" }
const _hoisted_13 = { class: "sidebar__link-image" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "sidebar__link-title" }
const _hoisted_16 = { class: "sidebar__link-content" }
const _hoisted_17 = { class: "sidebar__link-image" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "sidebar__link-title" }
const _hoisted_23 = { class: "sidebar__link-content" }
const _hoisted_24 = { class: "sidebar__link-image" }
const _hoisted_25 = ["src"]
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "sidebar__link-title" }
const _hoisted_28 = { class: "sidebar__link-content" }
const _hoisted_29 = { class: "sidebar__link-image" }
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.route,
          onClick: _ctx.hideSidebar,
          class: _normalizeClass(["main-nav__item", {'main-nav__item--selected': item.route === _ctx.route.name}]),
          "active-class": '',
          "exact-active-class": '',
          to: {name: item.route, query: item.query}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: require(`@/apps/public/assets/img/menu/${item.route}.svg`)
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`menu.items.${item.route}`)), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "class", "to"]))
      }), 128)),
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.doLogout()), ["prevent"])),
        class: "main-nav__item hide-sm"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: require(`@/apps/public/assets/img/menu/logout.svg`)
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('labels.logout')), 1)
      ])
    ]),
    (_ctx.isTrader || _ctx.isTraderOperator)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.usdtRate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('labels.rateUsdt')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("img", {
                      src: require('@/apps/public/assets/img/usdt.svg')
                    }, null, 8, _hoisted_14)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.usdtRate ? _ctx.numberFormatter.formatMoney(_ctx.usdtRate) : ''), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isTrader)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: {name:'settings'},
                class: "sidebar__link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('labels.telegram_bot_notifications')), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("img", {
                        src: require('@/apps/public/assets/img/tg.svg')
                      }, null, 8, _hoisted_18)
                    ]),
                    (_ctx.telegramMe?.username)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          _createTextVNode(_toDisplayString(_ctx.$t('labels.connectTo')) + " ", 1),
                          _createElementVNode("strong", null, "@" + _toDisplayString(_ctx.telegramMe.username), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('labels.connect')), 1))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.manualLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.manualLink,
                target: "_blank",
                class: "sidebar__link"
              }, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('labels.howToGuide')), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("img", {
                      src: require('@/apps/public/assets/img/instruction.svg')
                    }, null, 8, _hoisted_25)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.instruction')), 1)
                ])
              ], 8, _hoisted_21))
            : _createCommentVNode("", true),
          (_ctx.bankAppsLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: _ctx.bankAppsLink,
                target: "_blank",
                class: "sidebar__link"
              }, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('labels.bankMobileApp')), 1),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("img", {
                      src: require('@/apps/public/assets/img/app.svg')
                    }, null, 8, _hoisted_30)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.downloadApk')), 1)
                ])
              ], 8, _hoisted_26))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}